module.exports = __webpack_public_path__ + "static/img/why-4.ab02b8e7.jpg";